import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import routes from "./routing/routes";

// Redux store: one source of truth
import { Provider } from "react-redux";
import store from "./store/store";

render(
  <Provider store={store}>
    <BrowserRouter>{renderRoutes(routes)}</BrowserRouter>
  </Provider>,
  document.getElementById("landing")
);



// WEBPACK FOOTER //
// ./application/frontend/src/overview.jsx